import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deepKey',
})
export class DeepKeyPipe implements PipeTransform {

  transform(object: any, key: string | string[]): unknown {
    if (typeof key === 'string') {
      return object[key]
    } else {
      let value = object;
      for (let k of key) {
        if (value) {
          value = value[k]
        } else {
          return null
        }
      }
      return value;
    }
  }

}
